/**
 * Represents intents from the Search API.
 *
 * @public
 */
export var SearchIntent;
(function (SearchIntent) {
    /** The Search API is requesting a prompt for the user's location. */
    SearchIntent["NearMe"] = "NEAR_ME";
})(SearchIntent || (SearchIntent = {}));
//# sourceMappingURL=SearchIntent.js.map